import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect () {
    const targetElement = document.querySelector('[data-action="signer-order-hide#changeContentVisibility"]');

    if (targetElement) {
      const mockEvent = { target: targetElement };
      this.changeContentVisibility(mockEvent);
    }
  }

  changeContentVisibility(event) {
    const selectedValue = event.target.value;
    const containerDivsSet = new Set();

    document.querySelectorAll('.contract-signers').forEach(signersDiv => {
      signersDiv.querySelectorAll('div.signer-container').forEach(container => containerDivsSet.add(container));
    });

    const containerDivs = Array.from(containerDivsSet);

    if (selectedValue === 'false') {
      containerDivs.forEach((container) => {
        const orderEl = container.querySelector('.contract-order');
        const dragEl = container.querySelector('.drag-signer-icon');
        if (orderEl) orderEl.classList.remove('hidden');
        if (dragEl) dragEl.classList.remove('hidden');
      });
    } else {
      containerDivs.forEach((container) => {
        const orderEl = container.querySelector('.contract-order');
        const dragEl = container.querySelector('.drag-signer-icon');
        if (orderEl) orderEl.classList.add('hidden');
        if (dragEl) dragEl.classList.add('hidden');
      });
    }
  }
}
